import React from "react";
import NextLink from "next/link";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useTranslation } from "next-i18next";
import { MDXRemote } from "next-mdx-remote";

const Hero = ({ pageTitle, title1, title2, title3, subtitle }) => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Grid container justifyContent="center" spacing={4}>
      <Grid item container alignItems="center" xs={12} md={10}>
        <Box>
          <Box marginY={5}>
            {pageTitle && (
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "medium",
                }}
                gutterBottom
                color={"textSecondary"}
                align={"center"}
              >
                {pageTitle}
              </Typography>
            )}
            <Typography
              variant="h3"
              component="h1"
              color="textPrimary"
              align="center"
              sx={{
                fontWeight: 700,
              }}
            >
              {title1}{" "}
              <Typography
                color={"primary"}
                component={"span"}
                variant={"inherit"}
              >
                {title2}{" "}
              </Typography>
              {title3}
            </Typography>
          </Box>
          <Box marginBottom={5}>
            <Typography
              variant="h6"
              component="div"
              color="textSecondary"
              align="center"
            >
              {subtitle?.frontmatter ? <MDXRemote {...subtitle} /> : subtitle}
            </Typography>
          </Box>
          <Box align="center">
            <NextLink href="/demo" passHref>
              <Button
                variant="contained"
                color="primary"
                component="a"
                size="large"
                fullWidth={isMd ? false : true}
              >
                {t("request_a_demo.cta")}
              </Button>
            </NextLink>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Hero;
